import React from "react"
import { ArrowSubmitButton, ReimbursementDialogFraming, BackArrow } from "../shared/layouts"
import { Progress } from "#/components/views/modal/Progress"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"
import { DialogContentText, DialogTitle, Box } from "@carrotfertility/carotene-core"
import { DialogActionsBar, Form, FormRadioGroup } from "@carrotfertility/carotene-core-x"

export enum ExpenseProviderType {
  FERTILITY_CLINIC = "FERTILITY_CLINIC",
  OBGYN = "OBGYN"
}

export const FertilityCareProvider = (): JSX.Element => {
  const { send, back } = useStateMachine()
  const intl = useIntl()

  const { state, updateExpenseProviderType } = useReimbursementContext()

  const canSubmit = state.expenseProviderType?.value != null

  const handleContinueClick = (): void => {
    send(state.expenseProviderType?.value === ExpenseProviderType.OBGYN ? "OBGYN" : "")
  }

  const goBack = (): void => {
    updateExpenseProviderType(null)
    back()
  }

  const options = [
    { label: intl.formatMessage({ defaultMessage: "Fertility clinic" }), value: ExpenseProviderType.FERTILITY_CLINIC },
    { label: intl.formatMessage({ defaultMessage: "OB/GYN" }), value: ExpenseProviderType.OBGYN }
  ]
  return (
    <>
      <Progress
        numSteps={3}
        step={2}
        label={intl.formatMessage({ defaultMessage: "Provider Type" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <BackArrow onClick={goBack} />
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="Did you receive care from an eligible fertility clinic or an eligible OB/GYN?" />
        </DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.tokens.spacing.lg }}>
          <DialogContentText>
            <FormattedMessage defaultMessage="We need this information to process your expense accurately." />
          </DialogContentText>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "center" }
            }}
          >
            <Form onSubmit={() => null}>
              <FormRadioGroup
                aria-labelledby="step-heading"
                name="expenseProviderType"
                controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
                options={options}
                onChange={(e) => {
                  updateExpenseProviderType(options.find((o) => o.value === (e.target as HTMLInputElement).value))
                }}
              />
            </Form>
          </Box>
        </Box>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <ArrowSubmitButton enabled={canSubmit} onClick={handleContinueClick}>
            <FormattedMessage defaultMessage="Continue" />
          </ArrowSubmitButton>
        }
      />
    </>
  )
}
